import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@app/core/core.module';
import { SharedModule } from '@app/shared/shared.module';
import { GoogleChartsModule } from 'angular-google-charts';
import { NgxBootstrapModule } from '@app/ngx-bootstrap/ngx-bootstrap.module';

import { IndividualDataComponent } from './individual-data.component';
import { IndividualDataErrorComponent } from './individual-data-error/individual-data-error.component';
import { IndividualDataPlotsComponent } from './individual-data-plots/individual-data-plots.component';
import { IndividualPupilListComponent } from './individual-pupil-list/individual-pupil-list.component';
import { MatProgressSpinnerModule } from '@angular/material';

@NgModule({
    imports: [
        CoreModule,
        CommonModule,
        SharedModule,
        FormsModule,
        GoogleChartsModule,
        ReactiveFormsModule,
        NgxBootstrapModule,
        MatProgressSpinnerModule
    ],
    exports: [IndividualDataComponent],
    declarations: [
        IndividualDataComponent,
        IndividualDataErrorComponent,
        IndividualDataPlotsComponent,
        IndividualPupilListComponent
    ],
    providers: []
})
export class IndividualDataModule {}
